var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecurity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 13.3293C14.1652 12.9175 15 11.8062 15 10.5C15 8.84315 13.6569 7.5 12 7.5C10.3431 7.5 9 8.84315 9 10.5C9 11.8062 9.83481 12.9175 11 13.3293V15.5C11 16.0523 11.4477 16.5 12 16.5C12.5523 16.5 13 16.0523 13 15.5V13.3293ZM12 9.5C11.4477 9.5 11 9.94771 11 10.5C11 11.0523 11.4477 11.5 12 11.5C12.5523 11.5 13 11.0523 13 10.5C13 9.94771 12.5523 9.5 12 9.5Z",
    fill: "#011235"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.67207 1.46411C11.1642 0.855307 12.8455 0.855307 14.3376 1.46411L14.3387 1.46454L19.9075 3.74404C20.5087 3.98952 21.0011 4.44952 21.3385 4.94891C21.6759 5.44836 21.9199 6.07746 21.9199 6.72997L21.9199 6.73225L21.9099 11.12V11.1215C21.9091 16.4766 18.0435 21.4386 12.7762 22.8939L12.773 22.8947C12.2707 23.0317 11.729 23.0317 11.2267 22.8947L11.2235 22.8939C5.95568 21.4384 2.08984 16.4757 2.08984 11.12V6.72997C2.08984 6.08105 2.32883 5.45266 2.6662 4.95082C3.00318 4.44954 3.49585 3.98899 4.1034 3.74354L9.67207 1.46411ZM10.4276 3.31591L4.85333 5.59763C4.69226 5.66248 4.49098 5.82123 4.32601 6.06663C4.16086 6.31229 4.08984 6.5589 4.08984 6.72997V11.12C4.08984 15.5436 7.32301 19.7403 11.7541 20.9655C11.9112 21.0081 12.0885 21.0081 12.2456 20.9655C16.6767 19.7403 19.9099 15.5436 19.9099 11.12L19.9099 11.1177L19.9199 6.72997V6.72893C19.9196 6.56147 19.8485 6.31607 19.6812 6.06854C19.5138 5.82067 19.3106 5.66052 19.1522 5.59591L13.5821 3.31591C12.5745 2.905 11.4351 2.90498 10.4276 3.31591Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurity);
export default __webpack_public_path__ + "static/media/security.39288519df4804b211c5b50e3422d3ab.svg";
export { ForwardRef as ReactComponent };